// External
import React from "react";
import _ from "lodash";

// Helper function to get missing categories table configuration
export const getMissingCategoriesColumnList = () => {
  return [
    {
      id: "subject",
      label: "Subject",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
    },
    {
      id: "grade",
      label: "Grade",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
    },
    {
      id: "category",
      label: "Category",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
    },
  ];
};

export const getMissingCategoriesFeedData = data => {
  return _.map(data, item => {
    return {
      id: item.id,
      subject: item.subjectName,
      grade: item.gradeName,
      category: item.categoryName,
    };
  });
};

// Helper function to get associated data table configuration
export const getAssociatedDataColumnList = () => {
  return [
    {
      id: "type",
      label: "Type",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "20%" },
    },
    {
      id: "name",
      label: "Name",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "20%" },
    },
    {
      id: "url",
      label: "URL",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "CUSTOM",
      style: { width: "60%" },
    },
  ];
};

export const getAssociatedDataFeedData = data => {
  return data;
};

// Custom component function for rendering URL links
export const getCustomComponent = ({ column, columnData }) => {
  switch (column.id) {
    case "url":
      if (columnData) {
        return (
          <a
            href={columnData}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "var(--interactive-primary)",
              textDecoration: "underline",
              whiteSpace: "normal",
              wordWrap: "break-word",
              overflowWrap: "break-word",
              wordBreak: "break-word",
            }}
          >
            {columnData}
          </a>
        );
      }
      return "";

    default:
      return columnData || "";
  }
};
